export default "__VITE_ASSET__DlsuNlDX__"